import { type ReactNode } from 'react';

export function EmptyInfoCardTemplate(): ReactNode {
    return (
        <div className="p-4 flex flex-column gap-4">
            <h2 className="text-se70 p50-underline">No item selected</h2>
            <p>Please select a row from the table to view details here.</p>
        </div>
    );
}
